import { render } from "./SalesReportsTab.vue?vue&type=template&id=37912296&scoped=true&ts=true"
import script from "./SalesReportsTab.vue?vue&type=script&lang=ts"
export * from "./SalesReportsTab.vue?vue&type=script&lang=ts"

import "./SalesReportsTab.vue?vue&type=style&index=0&id=37912296&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37912296"]])

export default __exports__